<template>
  <div class="buttons-wrapper">
    <div class="d-flex align-items-center justify-content-center buttons-box">
      <div>
        <div
          class="tw-cursor-pointer tw-w-10 tw-h-10 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-bg-white hover:tw-bg-yellow-200 transition-colors"
          @click="isShowMenu = !isShowMenu"
        >
          <img :src="BracketsIcon" alt="" />
        </div>
      </div>

      <Vue2InteractDraggable
        v-if="isShowMenu"
        ref="vue-interactive"
        :interactXThreshold="20000"
        :interactYThreshold="20000"
        :interactOutOfSightXCoordinate="20000"
        :interactOutOfSightYCoordinate="20000"
        class="draggableSub"
        @mouseup.native="dragCard"
      >
        <div
          class="tw-bg-white tw-rounded-lg tw-shadow-shadow-2 tw-w-[472px] tw-p-6 tw-relative"
        >
          <div class="tw-absolute tw-top-3 tw-right-3">
            <v-btn
              icon
              dense
              absolute
              z-index="3"
              class="buttons-wrapper__close-button"
              @click="isShowMenu = !isShowMenu"
            >
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-tabs
            v-model="activeTab"
            height="26"
            color="primaryDark"
            class="tabs"
          >
            <v-tab v-for="tab in tabs" :key="`tab-${tab}`">
              <div class="tw-pb-3">{{ tab }}</div></v-tab
            >
          </v-tabs>
          <v-tabs-items v-model="activeTab">
            <v-tab-item
              v-for="(tabItem, index) in tabItems"
              :key="`tab-item-${index}`"
            >
              <v-list dense>
                <v-list-item
                  v-for="(tab, index) in tabItem"
                  :key="`tab-item-v-${index}`"
                  class="buttons-wrapper__list-item cursor-pointer"
                  @click="clicked(tab)"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="tab"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </Vue2InteractDraggable>
    </div>
  </div>
</template>

<script>
import { Vue2InteractDraggable } from 'vue2-interact';
import InfoIcon from '@/assets/img/info-svgrepo-com.svg';
import BracketsIcon from '@/assets/icons/brackets-icon.svg';

const VARIABLES = {
  Greetings: [
    'Hi {firstname},',
    'Hi {firstname lastname},',
    'Dear  {firstname},',
    'Dear {firstname lastname},',
    '{firstname},',
    '{firstname lastname},',
  ],
  Education: ['{most recent school}', '{most recent degree}'],
  Experience: [
    '{current company}',
    '{current job title}',
    '{previous company}',
    '{previous job title}',
  ],
  Skillsets: ['{top skill #1}', '{top skill #2}', '{top skill #3}'],
};

export default {
  name: 'OutreachTemplateButtons',
  components: {
    Vue2InteractDraggable,
  },

  data() {
    return {
      activeTab: 0,
      isShowMenu: false,
      InfoIcon,
      BracketsIcon,
    };
  },

  computed: {
    tabs() {
      return Object.keys(VARIABLES);
    },

    tabItems() {
      return Object.values(VARIABLES);
    },
  },

  watch: {
    isShowMenu(v) {
      if (v) {
        this.$emit('open');
      } else {
        this.$emit('close');
      }
    },
  },

  methods: {
    dragCard() {
      const { top, left } =
        this.$refs['vue-interactive'].$el.getClientRects()[0];

      this.$refs['vue-interactive'].$el.style.top = `${top}px`;
      this.$refs['vue-interactive'].$el.style.left = `${left}px`;
      this.$refs['vue-interactive'].$el.style.transition = `none`;
    },

    closeMenu() {
      this.isShowMenu = false;
    },

    clicked(variable) {
      this.$emit('insert-variable', variable);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './variables.scss';

.draggableSub {
  z-index: 100;
  position: fixed;
  top: 37%;
  left: 50%;
  transition: none !important;
}
.aa {
  background-color: yellowgreen;
  padding: 40px;
  z-index: 200;
}
.buttons-wrapper {
  &__button {
    border: 1px solid $border;
    background-color: #ffff !important;
    &::v-deep .v-btn__content {
      i {
        margin-right: 6px;
        color: $gray-dark !important;
      }
      span {
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 30px;
        text-transform: initial;
        color: $gray-dark;
      }
    }
  }
  &__close-button {
    top: 3px;
    right: 5px;
    z-index: 1;
  }
  &__list-item {
    transition: 0.3s;

    &.v-list-item {
      &:hover {
        background-color: rgba($primary-dark, 0.07);
      }
      .v-list-item__title {
        color: $gray-dark;
      }
    }
  }
}
.tabs.v-tabs {
  .v-slide-group__wrapper {
    .v-tab {
      text-transform: initial;
      letter-spacing: 0.48px;
    }
  }
}
.buttons-box {
  button {
    position: relative;
    z-index: 9;
  }
}
.z-20 {
  z-index: 9;
}
::v-deep {
  .v-slide-group__content {
    display: flex !important;
  }
}
</style>
